import React from 'react';
import Head from 'next/head';
import BaseHead, { blogPageMeta } from 'app/components/blog/BaseHead';
import he from 'he';

const { name, locale, url } = blogPageMeta;

const PageHead = ({ search }) => {
  const title = `You searched for ${search} - ${name}`;
  const searchUrl = `${url}search/${search}/`;
  const ldJson = {
    '@graph': [
      {
        '@type': 'SearchResultsPage',
        '@id': `${searchUrl}#webpage`,
        url: searchUrl,
        inLanguage: locale,
        name: he.encode(title),
        isPartOf: {
          '@id': `${url}#website`,
        },
      },
    ],
  };
  return (
    <Head>
      <BaseHead />
      <title>{title}</title>
      <meta name="robots" content="noindex,follow" />
      <meta property="og:type" content="object" />
      <meta property="og:title" content={title} />
      <meta property="og:url" content={searchUrl} />
      <meta property="twitter:title" content={title} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: BaseHead.buildLdJson(ldJson) }}
      />
    </Head>
  );
};

export default PageHead;
